/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_PlanInputs */



/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Partner_Add_Customer_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_plan = /** @type {((inputs?: Partner_Add_Customer_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarif")
	return /** @type {LocalizedString} */ ("Plan")
});